// UserQueueFormazione.jsx - Versione corretta
import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Divider,
  Checkbox,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  Avatar,
  Paper,
  Chip,
  Badge
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const UserQueueFormazione = ({
  iscritti = [],
  utentiIstr1 = 0,
  utentiIstr2 = 0,
  currentUserId,
  isManagerIstruttore,
  isIstruttore,
  isPresenceManagementEnabled,
  isDeleteEnabledForOperator,
  userlist = [],
  onDelete,
  onTogglePresenza
}) => {
  const maxIstr1 = utentiIstr1 || 0;
  const maxIstr2 = utentiIstr2 || 0;
  const sorted = [...iscritti].sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
  );

  const istr1Users = sorted.slice(0, maxIstr1);
  const istr2Users = sorted.slice(maxIstr1, maxIstr1 + maxIstr2);

  const renderUserItem = (u, idx, queuePosition) => {
    const userName = userlist.find(x => x.id === u.anaUserId)?.name || u.anaUserId;
    const isCurrentUser = u.anaUserId === currentUserId;
    const initials = userName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);

    return (
      <ListItem
        key={u.anaUserId}
        dense
        sx={{
          px: 0,
          py: 0.5,
          borderRadius: 1,
          '&:hover': {
            bgcolor: 'action.hover'
          }
        }}
      >
        <ListItemAvatar sx={{ minWidth: 40 }}>
          <Badge
            badgeContent={queuePosition}
            color="primary"
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            sx={{
              '& .MuiBadge-badge': {
                fontSize: '0.7rem',
                minWidth: '18px',
                height: '18px'
              }
            }}
          >
            <Avatar
              sx={{
                bgcolor: isCurrentUser ? '#2c5282' : 'grey.400',
                color: 'white',
                width: 32,
                height: 32,
                fontSize: '0.8rem'
              }}
            >
              {initials}
            </Avatar>
          </Badge>
        </ListItemAvatar>
        
        <ListItemText
          primary={
            <Typography
              variant="body2"
              sx={{
                fontWeight: isCurrentUser ? 'bold' : 'normal',
                color: isCurrentUser ? '#2c5282' : 'text.primary',
              }}
            >
              {userName}
            </Typography>
          }
          secondary={
            isPresenceManagementEnabled && u.isPresente === 1 && (
              <Chip 
                label="Presente" 
                size="small" 
                color="success" 
                variant="outlined"
                icon={<CheckCircleIcon />}
                sx={{ mt: 0.5, height: 20, fontSize: '0.7rem' }}
              />
            )
          }
        />
        
        <ListItemSecondaryAction>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {isPresenceManagementEnabled && (isManagerIstruttore || isIstruttore) && (
              <Checkbox id="ED-add-presence"
                size="small"
                checked={u.isPresente === 1}
                onChange={() => { console.log("Click",u.anaUserId, u.isPresente); onTogglePresenza?.(u.anaUserId, u.isPresente)}}
                sx={{ p: 0.5 }}
              />
            )}
            {(isManagerIstruttore || isIstruttore || (u.anaUserId === currentUserId && isDeleteEnabledForOperator )) && (
              <IconButton id="ED-remove-self"
                size="small"
                onClick={() => onDelete(u.id)}
                sx={{ 
                  color: 'text.secondary',
                  '&:hover': { color: 'error.main' }
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        </ListItemSecondaryAction>
      </ListItem>
    );
  };

  const renderSection = (users, title, startIndex = 1) => (
    <Paper 
      elevation={0} 
      sx={{ 
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'hidden'
      }}
    >
     <Box sx={{ 
        bgcolor: '#f5f5f5', 
        px: 2, 
        py: 1,
        borderBottom: '1px solid',
        borderColor: 'divider'
      }}>
        <Typography 
          variant="subtitle2" 
          sx={{ 
            color: '#2c5282',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}
        >
          <PersonIcon fontSize="small" />
          {title}
          <Chip 
            label={`${users.length}/${title.includes('1') ? utentiIstr1 : utentiIstr2}`} // CORREZIONE: usare utentiIstr2
            size="small"
            variant="outlined"
            sx={{ ml: 'auto', height: 20 }}
          />
        </Typography>
      </Box>

      {users.length === 0 ? (
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Nessun utente iscritto
          </Typography>
        </Box>
      ) : (
        <List dense sx={{ py: 0, pb: 1 }}>
          {users.map((u, idx) => renderUserItem(u, idx, startIndex + idx))}
        </List>
      )}
    </Paper>
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {renderSection(istr1Users, 'Utenti Istruttore 1', 1)}
      {renderSection(istr2Users, 'Utenti Istruttore 2', maxIstr1 + 1)}
    </Box>
  );
};

export default UserQueueFormazione;